/**
 * 用户
 */
import request from "../utils/http";

export function sendCode(data) { // 发送验证码
  return request({
    url: '/yuanhua/v2/user/sendCode',
    method: "post",
    data
  })
}

export function login(data) { // 登录
  return request({
    url: '/yuanhua/v2/user/login',
    method: "post",
    data
  })
}

export function getUserInfo(data) { // 获取登录用户信息
  return request({
    url: '/yuanhua/v2/user/loginInfo',
    method: "get",
    data
  })
}

export function getStuInfoByAuthCodeOrMobile(data) { // 根据激活码或手机号获取用户信息
  return request({
    url: '/yuanhua/v2/user/studentInfo',
    method: "post",
    data
  })
}

export function parentBindStudent(data) { // 家长绑定学生
  return request({
    url: '/yuanhua/v2/user/bindStudent',
    method: "post",
    data
  })
}

export function getUserInfoInApp(data) { // app内通过userid获取用户信息
  return request({
    url: '/yuanhua/v2/user/getStudentInfoOfPatriarch',
    method: "get",
    data
  })
}

export function getStudentByClassId(data) { // 根据班级id获取学生列表
  return request({
    url: '/yuanhua/v2/student/getStudentByClassId',
    method: "get",
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js